<template>
    <div>
        <v-list>
            <v-list-item class="wallet"
                         v-for="(wallet,index) in wallets"
                         :key="wallet.id"
                         :class="{'wallet-selected':wallet.checked === true}"
                         @click.prevent="selectWallet(index)">
                <v-list-item-avatar class="wallet-icon">
                    <i class="fas fa-wallet" style="color: #ffffff"></i>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="wallet-name">{{wallet.name}}</v-list-item-title>
                    <v-list-item-subtitle class="wallet-subtitle">
                        Crédito R$ {{wallet.balance_credit | integerToMoney | integerToMoney2}}
                    </v-list-item-subtitle>
<!--                    <v-list-item-subtitle class="wallet-subtitle">{{wallet.pivot !== undefined ? 'Compartilhada' : 'Pessoal'}}</v-list-item-subtitle>-->
                </v-list-item-content>
                <v-list-item-action v-if="wallet.checked === true">
                    <i class="fas fa-check" style="color: #000"></i>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    export default {
        name: "SelectWallet",
        props:[
          'shares'
        ],
        data:function () {
            return{
                wallets:[],
            }
        },
        mounted() {
            axios.get('/api/users/driver/me/wallet').then(response =>{

              this.wallets = response.data.data;
              this.wallets.forEach( wallet => {
                Vue.set(wallet,'checked',false);
              });
              this.selectWallet(0);
            });
        },
        methods:{
            selectWallet:function (index) {
                this.wallets.forEach( wallet => {
                   Vue.set(wallet,'checked',false);
                });
                Vue.set(this.wallets[index],'checked',true);
                this.$emit('update:wallet',this.wallets[index]);
            }
        }
    }
</script>

<style scoped>
    .wallet{
        border: 2px solid transparent;
    }

    .wallet-name{
        font-size: 16px;
        font-family: Roboto-Black;
        color: #9b9b9b;
    }

    .wallet-icon{
        background: #9b9b9b;
    }

    .wallet-subtitle{
        font-size: 12px;
        font-family: Roboto-Regular;
        color: #000;
    }

    .wallet-selected{
        background: #f8f8f8;
    }

    .wallet-selected .wallet-name, .wallet-selected .wallet-subtitle{
        color: #000 !important;
    }

    .wallet-selected .wallet-icon{
        background: #000;
    }

    @media only screen and (max-width: 500px) {
        .wallet-icon{
            display: none;
        }
    }
</style>
